import { loadAttachmentFile } from '../../../../components/patient-attachments/AuthFile';
import { normalizeCrop } from './applicationFigures';

/** Mede a imagem de uma object URL ({ width, height }); 0 x 0 quando falha. */
function measureImage(url) {
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => resolve({ width: image.naturalWidth, height: image.naturalHeight });
    image.onerror = () => resolve({ width: 0, height: 0 });
    image.src = url;
  });
}

/**
 * Baixa (ou pega do cache) as fotos de fundo de um mapa para o PDF e mede cada
 * uma, para o template recortar a foto no quadro da vista.
 *
 * `backgrounds`: { [view]: { attachmentId, crop } } do registro.
 * @param {function} loader GetPatientAttachmentFile do DataProvider
 * @returns {Promise<object>} { [view]: { url, width, height, crop } }; uma
 * vista cuja foto falhar fica de fora e o template usa o desenho.
 */
export async function loadPhotoFigures(loader, backgrounds) {
  const figures = {};
  const entries = Object.entries(backgrounds || {}).filter(([, background]) => background && background.attachmentId);
  if (!loader || entries.length === 0) return figures;

  await Promise.all(entries.map(([view, background]) =>
    loadAttachmentFile(loader, background.attachmentId, 'full')
      .then((entry) => measureImage(entry.url).then((size) => {
        if (size.width > 0) figures[view] = { url: entry.url, ...size, crop: normalizeCrop(background.crop) };
      }))
      .catch(() => {})
  ));

  return figures;
}
